<template>
  <eva-main @back="goBack">
    <template slot="nav">
      <div class="classNav">
        <p>
           <span v-if="classInfo.is_special_train === 1">
            【快】
          </span>
          {{ classInfo.name }}
        </p>
        <div class="btns">
          <div v-if="showScoreBtn"
               class="btn"
               @click="lookScore">成绩</div>
          <div class="btn"
               @click="lookClass">培训班</div>
          <div v-if="isShowComplaint > 0" class="btn"
               @click="showfeeback('complaint',0)">投诉</div>
          <div v-if="isShowAppeal > 0" class="btn"
               @click="showfeeback('appeal',1)">申诉</div>
          <div v-if="isShowOther > 0" class="btn" @click="showfeeback('other',2)">反馈</div>
          
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="evaMain">
        <template v-if="showInfo">
          <div class="userInfo">
            <div class="left" @click="greetMoment">
              <img :src="!classInfo.moment_picture ? userImg : classInfo.moment_picture"
                   @error="imgError"
                   alt="">
              <div class="pos">
                <yioks-status class="status"
                  :status="classInfo.status"></yioks-status>
                <div class="btnWrap">
                  <div class="btn">精彩瞬间
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="line" v-if="['C', 'D', 'early','L1','L2','L3' ].includes( classInfo.class_level)">
                <p>培训日期：{{classInfo.start_date | time(false)}} 至 {{classInfo.end_date | time(false)}}</p>
              </div>
              <div class="line" v-else style="display: flex">
                <p>培训第一阶段：{{classInfo.dataPhase[0].start_date | time(false)}} 至 {{classInfo.dataPhase[0].end_date | time(false)}}</p>
                <p style="margin: 0 ">培训第二阶段：{{classInfo.dataPhase[1].start_date | time(false)}} 至 {{classInfo.dataPhase[1].end_date | time(false)}}</p>
              </div>
              <div class="line">
                <p>训练场地：{{classInfo.training_address}}</p>
              </div>
              <div class="line">
                <p>理论课场地：{{classInfo.theory_address}}</p>
              </div>
              <div class="line">
                <p>
                  <span>
                    主讲师：<span class="link" @click="lookTeaDetail(classInfo.teacher_off_ids)">{{classInfo.teacher_off_name}}</span>
                  </span>
                  <span v-if="classInfo.teacher_name">助理讲师：
                    <span class="link"
                      v-for="(item, index) in assistant.name"
                      @click="lookTeaDetail(assistant.ids[index])">
                      {{item + (index == assistant.name.length-1 ? '':'，')}}
                    </span>
                  </span>
                  <span v-if="classInfo.lecturer_assistant_name">讲师助理：
                    <span class="link"
                      v-for="(item, index) in lecturer_assistant.name"
                      @click="lookTeaDetail(lecturer_assistant.ids[index])">
                      {{item + (index == lecturer_assistant.name.length-1 ? '':'，')}}
                    </span>
                  </span>
                <span v-if="classInfo.teacher_zhuli_names">
                  讲师助理：
                  <span
                    class="link"
                    v-for="(item, index) in teacher_zhuli.name"
                    :key="index"
                    @click="lookOver(teacher_zhuli.ids[index])"
                  >{{
                      item +
                      (index == teacher_zhuli.name.length - 1 ? "" : "，")
                    }}</span
                  >
                </span>
                </p>
              </div>
            </div>
          </div>
          <div class="userType">
            <p v-for="(item, index) in list"
               :key="index"
               :class="{active: idx === index}"
               @click="switchTab(index, item.id, item.type, item.name)">
              <strong>{{item.name}}</strong>
            </p>
          </div>
        </template>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
        <div class="scrollArea">
          <vue-scroll :ops="ops" ref="vs">
            <div class="wrap">
              <div class="item">
                <div class="title">
                  <v-icon name="user-friends"
                          scale="1.7"></v-icon>
                  <p><strong>本培训班学员对{{obj_type|tabType}}{{obj_name}}的调查统计</strong></p>
                </div>
                <template v-if="stuStatus " >
                  <eva-charts :star="stuStar"
                    :eat="eat_sleep_score_list"
                    :practice_room="practice_room_score_list"
                    :practice_team="practice_team_score_list"
                    :theory_room="theory_room_score_list"
                    :train_clothing="train_clothing_socre_list"
                              :question="stuQuestion"
                  :showStar="obj_type!=='classEva'"
                  :showPracticeTeam=" obj_type==='organization' && ['GB','GA','F1','F2','B','A','PRO' ].includes( classInfo.class_level) "
                    :showScore="obj_type==='organization' && showScore"></eva-charts>
                  <div class="splitLine"></div>
                  <eva-opinions :ids="opinionId" :cid="c_id" ref="evaOpinion"></eva-opinions>
                </template>
                <template v-if="stuEmpty">
                  <yioks-empty :h="'300px'"></yioks-empty>
                </template>
              </div>
              <div class="item">
                <template v-if="orgStatus">
                  <div class="title">
                    <v-icon name="sitemap"
                            scale="1.7"></v-icon>
                    <p v-if="titleFlag">
                      <strong>{{classInfo.org_name}}对本培训班{{obj_type|tabType}}{{obj_name}}的调查统计</strong>
                    </p>
                    <p v-else>
                      <strong>主讲师{{classInfo.teacher_off_name}}对{{classInfo.org_name}}的调查统计</strong>
                    </p>
                  </div>
                  <div class="line" v-if="orgStar">
                    <p><strong>对{{obj_type|tabType}}{{obj_name}}的综合满意度</strong></p>
                    <div class="content">
                      <yioks-star :starNum="orgStar"
                                  :isEdit="false"></yioks-star>
                    </div>
                  </div>
                  <div class="line">
                    <p><strong>存在以下现象</strong></p>
                    <div class="content marginLeft">
                      <yioks-question :contsList="orgQuestion"
                                      :isEdit="false"></yioks-question>
                    </div>
                  </div>
                  <div class="line">
                    <p><strong>情况反馈</strong></p>
                    <div class="content marginLeft">
                      <div class="opinions">
                        <p>{{otherOpinions}}</p>
                      </div>
                    </div>
                  </div>
                </template>
                <!--<template v-if="orgEmpty">-->
                  <!--<yioks-empty :h="'300px'"></yioks-empty>-->
                <!--</template>-->
              </div>
            </div>
          </vue-scroll>
        </div>
        </template>
      </div>
    </template>
  </eva-main>
</template>

<script>
  import userImg from "@/assets/images/class_logo.png";
  import ops from "@/assets/js/vuescrollOption";
  import "vue-awesome/icons/user-friends";
  import "vue-awesome/icons/sitemap";
  import {classDetailInfo} from "@/api/common/api";
  import {evaClass} from "@/api/system_manager/api";
  import fiveMixins from '@/minix/fiveMixins';

  export default {
    name: "eva-class-detail",
    mixins: [fiveMixins],
    data() {
      return {
        userImg,
        ops: ops(),
        c_id: this.$route.query.id,
        classInfo: {},
        showInfo: false,
        list: [],
        titleFlag: true,
        idx: 0,
        obj_type: "",
        obj_name: "",
        opinionId: {
          obj_id: "",
          tpl_id: "1",
        },
        stuStatus: false,
        stuEmpty: false,
        stuStar: [],
        showScore:false,
        theory_room_score_list: [],
        practice_room_score_list: [],
        eat_sleep_score_list: [],
        practice_team_score_list: [],
        train_clothing_socre_list: [],
        stuQuestion: {
          yes: [],
          no: [],
          opt: [],
        },
        orgStatus: false,
        orgEmpty: false,
        orgStar: "",
        orgQuestion: [],
        otherOpinions: "",
        showScoreBtn: false,
        assistant: {
          name: [],
          ids: [],
        },
        lecturer_assistant: {
          name: [],
          ids: [],
        },
        teacher_zhuli: {
          name: [],
          ids: [],
        },
        isLoading: true,
        isShowAppeal: 0,
        isShowOther: 0,
        isShowComplaint: 0,
      };
    },
    components: {
      "eva-main": () => import("@/components/LayOut/Common/up-down"),
      "eva-charts": () => import("@/components/Evaluation/Echarts"),
      "eva-opinions": () => import("@/components/Evaluation/other-opinions"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-star": ()=>import("@/components/Rating/Rating"),
      "yioks-question": ()=>import("@/components/EvaluaConts/EvaluaConts"),
      "yioks-status": () => import("@/components/Tips/Status"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
    },
    filters: {
      tabType(type) {
        switch (type) {
          case "official": type = "主讲师"; break;
          case "assistant": type = "助理讲师"; break;
          case "lecturer_assistant": type = "讲师助理"; break;
//          case "goalkeeper": type = "守门员专项讲师"; break;
//          case "physical": type = "体能专项讲师"; break;
          default: type = "";
        }
        return type;
      },
    },
    created() {
      this.getClassInfo();
      this.setTpl();
    },
    methods: {
      setTpl() {
         if(this.isFive) {
           this.$set(this.opinionId, 'tpl_id', '200')
         }
      },
      goBack() {
        this.$router.go(-1);
      },
      getClassInfo() {
        classDetailInfo({c_id: this.c_id})
          .then((res)=>{
            // console.log(res);
            if(Number(res.data.status) === 0) {
              const {class_info,dataPhase,isShowComplaint,isShowAppeal,isShowOther} = res.data.result;
              this.classInfo = class_info;
              this.isShowComplaint = isShowComplaint;
              this.isShowAppeal = isShowAppeal;
              this.isShowOther = isShowOther;
              dataPhase && (this.classInfo.dataPhase=dataPhase);
              const idArr = class_info.teacher_ids && class_info.teacher_ids.split(",");
              idArr&&this.$set(this.assistant, "ids", idArr);
              const nameArr = class_info.teacher_name && class_info.teacher_name.split(",");
              nameArr&&this.$set(this.assistant, "name", nameArr);
              let tempArr = [];
              if(idArr&&nameArr) {
                tempArr = nameArr.map((item, index)=>{
                  return {
                    id: idArr[index].toString(),
                    name: item,
                    type: "assistant"
                  };
                });
              }
              const idArr1 = class_info.lecturer_assistant_ids && class_info.lecturer_assistant_ids.split(",");
              idArr1&&this.$set(this.lecturer_assistant, "ids", idArr1);
              const nameArr1 = class_info.lecturer_assistant_name && class_info.lecturer_assistant_name.split(",");
              nameArr1&&this.$set(this.lecturer_assistant, "name", nameArr1);
              let tempArr1 = [];
              if(idArr1&&nameArr1) {
                tempArr1 = nameArr1.map((item, index)=>{
                  return {
                    id: idArr1[index].toString(),
                    name: item,
                    type: "lecturer_assistant"
                  };
                });
              }
  
              const nameArrZhuli =
                class_info.teacher_zhuli_names &&
                class_info.teacher_zhuli_names.split(",");
              nameArrZhuli && this.$set(this.teacher_zhuli, "name", nameArrZhuli);
              const idArrZhuli =
                class_info.teacher_zhuli_ids &&
                class_info.teacher_zhuli_ids.split(",");
              idArrZhuli && this.$set(this.teacher_zhuli, "ids", idArrZhuli);
              
              // 2023.03.01
              if(class_info.start_date>1677600000000){
                this.list = [...this.list,
                  {
                    id: this.classInfo.c_id,
                    name: "培训班整体情况",
                    type: "classEva"
                  }
                ]
              }
              this.list = [
                ...this.list,
                {
                  id:  class_info.teacher_off_ids.toString(),
                  name: class_info.teacher_off_name,
                  type: "official"
                },
                ...tempArr,
                ...tempArr1,
                {
                  id: class_info.org_id.toString(),
                  name: class_info.org_name,
                  type: "organization"
                }
              ];
              if(class_info.class_level === 'B' || class_info.class_level === 'A'|| class_info.class_level === 'PRO'){
                this.list = [...this.list,
                  {
                    id: "0",
                    name: "守门员专项讲师",
                    type: "goalkeeper"
                  },{
                    id: "0",
                    name: "体能专项讲师",
                    type: "physical"
                  }
                ]
              }
              // 2023.03.01
              if(class_info.start_date>1677600000000){
                this.list = [...this.list,
                  {
                    id: this.classInfo.c_id,
                    name: "协调员",
                    type: "linkman"
                  }
                ]
              }
              
              // console.log(this.list);
              this.$set(this.opinionId, "obj_id", this.list[this.idx].id);
              this.obj_type = this.list[this.idx].type;
              this.obj_name = this.list[this.idx].name;
              this.showInfo = true;
              this.getEvaClass();
            }
          })
          .catch((err)=>{
            console.error(err);
          });
      },
      getEvaClass(callback = () => {}) {
        this.isLoading = true;
        evaClass({c_id: this.c_id, obj_id: this.opinionId.obj_id, obj_type: this.obj_type})
          .then((res)=>{
            // console.log(res);
            if(Number(res.data.status) === 0) {
              let {more_status, small_status} = res.data.result.survey_status;
              more_status = Number(more_status) !== 0;
              small_status = Number(small_status) !== 0;
              if (more_status) {
                const {survey_more} = res.data.result;
                this.stuStar = survey_more.survey_more_star;
                this.theory_room_score_list = survey_more.survey_more_theory_room_score;
                this.practice_room_score_list = survey_more.survey_more_practice_room_score;
                this.eat_sleep_score_list = survey_more.survey_more_eat_sleep_score;
                this.practice_team_score_list = survey_more.survey_more_practice_team_score;
                this.train_clothing_socre_list = survey_more.survey_more_train_clothing_socre;
                this.$set(this.stuQuestion, "yes", survey_more.survey_more_question_yes);
                this.$set(this.stuQuestion, "no", survey_more.survey_more_question_no);
                this.$set(this.stuQuestion, "opt", survey_more.survey_more_question_option);
                this.theory_room_score_list.map(item=>{
                  if(item>0){
                    this.showScore = true;
                  }
                });
              }
              if (small_status) {
                const {survey_small} = res.data.result;
                this.orgStar = survey_small.star;
                this.orgQuestion = survey_small.smallList;
                this.otherOpinions = survey_small.other_eva;
              }
              this.stuStatus = more_status;
              this.stuEmpty = !more_status;
              this.orgStatus = small_status;
              this.orgEmpty = !small_status;
              this.showScoreBtn = res.data.result.isShowScore;
              callback();
              this.isLoading = false;
            }
          })
          .catch((err)=>{
            this.isLoading = false;
            console.error(err);
          });
      },
      imgError() {
        this.$set(this.classInfo, "moment_picture", this.userImg);
      },
      switchTab(idx, id, type, name) {
        if(idx === this.idx){return;}
        this.idx = idx;
        this.$set(this.opinionId, "obj_id", id);
        this.obj_type = type;
        this.obj_name = name;
        if (this.$refs['evaOpinion']){
          this.$refs['evaOpinion'] && (this.$refs['evaOpinion'].page = 1);
        }
        if(type === "organization") {
          if(this.isFive) {
            this.$set(this.opinionId, "tpl_id", "201");
          } else {
            this.$set(this.opinionId, "tpl_id", "2");
          }
          
          this.titleFlag = false;
        }else if(type === "goalkeeper"){
          this.$set(this.opinionId, "tpl_id", "7");
          this.titleFlag = true;
        }else if(type === "physical"){
          this.$set(this.opinionId, "tpl_id", "8");
          this.titleFlag = true;
        }else if(type === "classEva"){
          if(this.isFive) {
            this.$set(this.opinionId, "tpl_id", "205");
          } else {
            this.$set(this.opinionId, "tpl_id", "10");
          }
          this.titleFlag = true;
        }else if(type === "linkman"){
          if(this.isFive) {
            this.$set(this.opinionId, "tpl_id", "199");
          } else {
            this.$set(this.opinionId, "tpl_id", "11");
          }
          this.titleFlag = true;
        }else{
          if(this.isFive) {
            this.$set(this.opinionId, "tpl_id", "200");
          } else {
            this.$set(this.opinionId, "tpl_id", "1");
          }
          
         
          this.titleFlag = true;
        }
        this.getEvaClass(() => {
          // this.$refs['vs'].scrollTo({ y: 0 });
        });
      },
      lookClass() {
        this.$router.push({
          path: 'class_detail',
          query: {
            c_id: this.c_id
          }
        });
      },
      lookScore() {
        this.$router.push({
          path: 'look_score',
          query: {
            c_id: this.c_id
          }
        });
      },
      showfeeback(feedback_type,idx) {
        /* 系统管理员查看申述 */
        this.$router.push({
          path: "feedback",
          query: {
            c_id: this.c_id,
            org_id: this.classInfo.org_id,
            feedback_type: feedback_type,
            idx: idx,
          },
        });
      },
      lookTeaDetail(id) {
        this.$router.push({path: 'td', query: {id,}});
      },
      lookOver(id) {
        // this.$router.push({path: 'od', query: {id: id}});
        this.$router.push({ path: "st", query: { id: id } });
      },
      greetMoment() {
        // console.log("精彩瞬间~");
        // this.$router.push({path: "/teacher/won", query: {c_id: this.classInfo.c_id}});
        this.$router.push({path: "/system/won", query: {"c_id": this.c_id}});
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .classNav {
    display: flex;
    flex: 1 1 auto;
    justify-content: space-between
    align-items: center;
    padding: 0 15px 0 0;
    font-size: $font_size_big;
    .btns {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      .btn {
        box-sizing: border-box;
        padding: 6px 15px;
        margin: 0 0 0 10px;
        color: $color_white;
        font-size: $font_size_medium;
        background-color: $color_suc;
        cursor: pointer;
      }
    }
  }
  .evaMain {
    width: 100%;
    height: 100%;
    background-color: $block_bg_color_base;
    .userInfo {
      height: 140px;
      margin: 0 30px;
      padding: 15px 0;
      display: flex;
      .left {
        height: 100%;
        flex: 0 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        img {
          width: 150px;
          height: 110px;
        }
        .pos {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          user-select: none;
          .status {
            margin: 0 0 0 10px;
          }
          .btnWrap {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            bottom: 0;
            .btn {
              width: 100px;
              height: 28px;
              margin: 0 0 1px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: $color_err;
            }
          }
        }
      }
      .right {
        height: 100%;
        padding: 0 0 0 30px;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: $font_size_medium;
        line-height: $font_size_medium;
        .line {
          display: flex;
          align-items: flex-end;
          .link {
            color: $color_suc;
            cursor: pointer;
            margin: 0;
          }
          p {
            margin: 0 30px 0 0;
            span {
              margin: 0 30px 0 0;
            }
          }
          .username {
            font-size: $font_size_big;
            line-height: $font_size_big;
          }
        }
      }
    }
    .userType {
      height: 40px;
      margin: 0 30px;
      display: flex;
      border-bottom: 1px solid $color_white;
      p {
        margin: 0 20px 0 0;
        padding: 0 0 5px 0;
        font-size: $font_size_big;
        user-select: none;
        cursor: pointer;
      }
      .active {
        color: $color_suc;
        border-bottom: 3px solid $color_suc;
        margin: 0 20px -1px 0;
      }
    }
    .loading-wrap-root{
      top: 200px;
    }
    .scrollArea {
      height: calc(100% - 180px);
      padding: 10px 0;
      .wrap {
        width: 100%;
        padding: 0 30px;
        .item {
          width: 100%;
          /*padding: 0 0 0 20px;*/
          margin: 0 0 30px 0;
          box-sizing: border-box;
          .title {
            padding: 10px 0;
            margin: 0 0 10px 0;
            display: flex;
            align-items: center;
            font-size: 20px;
            border-bottom: 1px solid $color_white;
            p {
              margin: 0 0 0 10px;
            }
          }
          .splitLine {
            height: 30px;
          }
          .line {
            p {
              font-size: $font_size_big;
            }
            .content {
              padding: 30px 0;
              &.marginLeft {
                margin: 0 0 0 50px;
              }
              .opinions {
                min-height: 60px;
                padding: 5px;
                color: $color_black;
                background-color: $color_white;
                p {
                  font-size: $font_size_base;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
